export function loadPayPalScript(clientId, currency = "USD") {
  return new Promise((resolve, reject) => {
    // If already loaded, resolve immediately
    if (window.paypal) {
      return resolve(window.paypal);
    }

    // Check if script is already being added
    const existingScript = document.getElementById("paypal-sdk");
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.paypal));
      existingScript.addEventListener("error", reject);
      return;
    }

    // Otherwise, create and add script
    const script = document.createElement("script");
    script.id = "paypal-sdk";
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}`;
    script.async = true;
    script.onload = () => resolve(window.paypal);
    script.onerror = reject;

    document.body.appendChild(script);
  });
}
